import { SizeType } from 'antd/es/config-provider/SizeContext';
import classNames from 'classnames';
import { memo } from 'react';
import styled, { css } from 'styled-components';
import { prop, switchProp } from 'styled-tools';
import type { Color } from 'components/colors';
import { ClassNamePropsWithChildren } from 'components/ozone-component';

type CustomSizeType = SizeType | 'xsmall';

interface IconShellProps extends ClassNamePropsWithChildren {
  icon: React.ReactNode;
  size?: CustomSizeType;
  dataTestId?: string;
  onClick?: () => void;
}

const Shell = styled.div<{ size: CustomSizeType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  ${switchProp(prop('size', 'middle'), {
    middle: css`
      height: var(--input-height-default);
      min-width: var(--input-height-default);
      width: var(--input-height-default);
    `,
    small: css`
      height: var(--input-size-sm);
      min-width: var(--input-size-sm);
      width: var(--input-size-sm);
    `,
    large: css`
      height: var(--input-height-lg);
      min-width: var(--input-height-lg);
      width: var(--input-height-lg);
    `,
    xsmall: css`
      height: var(--input-size-xs);
      min-width: var(--input-size-sm);
      width: var(--input-size-sm);
    `,
  })};
`;

export const IconShell = (props: IconShellProps) => {
  const { icon, size = 'middle', className, dataTestId, onClick } = props;

  return (
    <Shell
      onClick={onClick}
      size={size}
      className={classNames('icon-shell', className)}
      data-cy={dataTestId}
    >
      {icon}
    </Shell>
  );
};

export const IconWrapper = styled.span`
  color: var(--icon-primary);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const MemoedIconShell = memo(IconShell);

export const IconWrapperColor = styled.div<{ color: Color }>`
  color: ${(props) => `var(--${props.color}-60)`};
  background-color: ${(props) => `var(--${props.color}-20)`};
  padding: var(--spacing-02);
  width: var(--spacing-07);
  height: var(--spacing-07);
  border-radius: var(--border-radius-base);
  display: flex;
  justify-content: center;
  align-items: center;
`;
